import type { StateCreator } from 'zustand'
import type { DashboardStore, PersistMutator } from './index'

// Single shared reference for "no overrides". Selectors compare by identity in
// some consumers, so every "empty" must be the same array.
export const EMPTY_FLAGS: readonly string[] = []

export interface FeatureFlagsSlice {
  devFlagOverrides: readonly string[]
  setDevFlagOverrides: (flags: readonly string[]) => void
  clearDevFlagOverrides: () => void
}

export const createFeatureFlagsSlice: StateCreator<DashboardStore, PersistMutator, [], FeatureFlagsSlice> = (
  set,
) => ({
  devFlagOverrides: EMPTY_FLAGS,
  setDevFlagOverrides: (flags) => set({ devFlagOverrides: flags.length === 0 ? EMPTY_FLAGS : flags }),
  clearDevFlagOverrides: () => set({ devFlagOverrides: EMPTY_FLAGS }),
})
